import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    container: css({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        border: isHosTheme
            ? `0.5px solid ${theme.palette.secondary.dark}`
            : `1px solid ${theme.palette.grey[600]}`,
        borderRadius: isHosTheme ? theme.custom.borderRadius[23] : 0,
    }),
    marginTop: css({
        marginTop: '10px',
    }),
    wrapper: css({
        width: '100%',
        display: 'flex',
        padding: '20px',
        gap: '20px',
        background: theme.palette.common.white,
        ...(isHosTheme && {
            borderRadius: theme.custom.borderRadius[23],
        }),
    }),
    adjustBorder: css({
        ...(isHosTheme && {
            border: 'none',
            borderRadius: '23px 23px 0 0',
        }),
    }),
    roomInfo: css({
        paddingTop: '5px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        textAlign: 'left',
        gap: '5px',
        '& > h4': {
            ...(isHosTheme && {
                lineHeight: '120%',
            }),
        },
    }),
    image: css({
        width: '100%',
        height: '133px',
        objectFit: 'cover',
        minWidth: '146px',
        flex: 1,
        [theme.breakpoints.up('lg')]: {
            height: isHosTheme ? '130px' : '115px',
        },
        ...(isHosTheme && {
            borderRadius: theme.custom.borderRadius[23],
        }),
    }),
    imageSmall: css({
        width: '165px',
        height: '133px',
        ...(isHosTheme && {
            borderRadius: theme.custom.borderRadius[23],
        }),
    }),
    mainInfo: css({
        color: isHosTheme ? theme.palette.primary.main : theme.palette.text.primary,
    }),
    subInfo: css({
        color: isHosTheme ? theme.palette.text.primary : theme.palette.text.secondary,
    }),
    discount: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        padding: '6px 12px',
        color: theme.palette.common.white,
        background: theme.palette.success.main,
    }),
    mobileRoom: css({
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
    }),
    mobileRoomTitle: css({
        width: '100%',
        border: `1px solid ${theme.palette.grey[600]}`,
        padding: '15px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '20px',
        cursor: 'pointer',
        ...(isHosTheme && {
            borderRadius: theme.custom.borderRadius[23],
            border: `0.5px solid ${theme.palette.secondary.dark}`,
        }),
    }),
    roomTitle: css({
        ...(isHosTheme && {
            color: theme.palette.primary.main,
        }),
    }),
    roomCardExpanded: css({
        transform: 'rotate(180deg)',
    }),
    roomCardWrapper: css({
        marginTop: '10px',
    }),
};
